var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.categories),function(category){return _c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"p-2 rounded",style:(_vm.borderColor())},[_c('Category',{attrs:{"mode":_vm.mode,"category":category}}),(_vm.mode !=='trash'  )?_c('categories',{attrs:{"mode":_vm.mode,"categories":category.children}}):_vm._e()],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }